export const FORMAT_LLLL = 'dddd, D MMMM';
export const FORMAT_LLL = 'ddd, D MMM';
export const FORMAT_LT = 'h:mm A';
export const PHONE_NUMBER_REGEX =
  /^(?:([+]\d{1,4})[-.\s]?)?(?:[(](\d+)[)][-.\s]?)?(\d([-.\s]?\d+)+)$/;
